import login_bg from "./login_bg.png";
import no_data from "./no_data.png";
import pdf_icon from "./pdf_icon.svg";
import logo from "./logo.png";
import logo1 from "./logo1.png";
import sample1 from "./sample1.png";
import sample2 from "./sample2.png";
import sample3 from "./sample3.png";

export const images = {
  login_bg,
  no_data,
  pdf_icon,
  logo,
  logo1,
  sample1,
  sample2,
  sample3,
};
